/**
 * Check if any member in array1 equals the member in array2
 *
 * @param {Array} array1
 * @param {Array} array2
 * @returns {Array}
 */
export function arrayIntersection(array1: Array<any>, array2: Array<any>): Array<any> {
    return array1.filter(value => -1 !== array2.indexOf(value));
}

/**
 * Ensure that all terms are in the target array.
 *
 * @param {array} terms
 * @param {array} targetArray
 * @returns {boolean}
 */
export function arrayIncludesAllTerms(terms: Array<any>, targetArray: Array<any>): boolean {
    return arrayIntersection(terms, targetArray).length === terms.length;
}

/**
 * Ensure that every member of array1 is in array2, and that the sizes match.
 * @param {Array} array1
 * @param {Array} array2
 * @return {boolean}
 */
export function arrayMatch(array1: Array<any>, array2: Array<any>): boolean {
    // If both arrays are null, return true. If one is null and the other is not, return false
    if (!array1 || !array2) return array1 === array2;

    // If the sizes do not match, clearly the arrays do not match
    else if (array1.length !== array2.length) return false;

    // Now we just need to ensure that the intersection of both arrays is equal
    else return arrayIntersection(array1, array2).length === array1.length;
}

/**
 * Find elements that are in source, but not target (first result),
 * then elements that are in target, but not source (second result).
 *
 * @param {Array} source
 * @param {Array} target
 * @return {{onlyInSource: Array, onlyInTarget: Array}}
 */
export function arrayExclusions(source: Array<any>, target: Array<any>): { onlyInSource: Array<any>; onlyInTarget: Array<any>; } {
    const onlyInSource = Array.isArray(source) && !(Array.isArray(target))
                         ? source
                         : source.filter(item => !target.includes(item));

    const onlyInTarget = Array.isArray(target) && !(Array.isArray(source))
                         ? target
                         : target.filter(item => !source.includes(item));

    return {onlyInSource, onlyInTarget};
}

/**
 * Merge elements of two arrays into a single array.
 *
 * @param {any[]} a1
 * @param {any[]} a2
 * @returns {any[]}
 */
export function arrayMerge(a1: any[], a2: any[]): any[] {
    return a1.concat(a2.filter(e => !a1.includes(e)));
}